<ng-container *ngIf="!isLoading else showLoader">

    <ng-container *ngIf="step === 1">
        <form class="cas-form-floating push-up-2" [formGroup]="migrationForm">
            <p>{{existingContactCountMessage}}</p>
            <ng-container *ngIf="existingContactCount === 0">
                <p>It is safe for you to remove this contact type. Use the "Complete" button to finish.</p>
            </ng-container>
            <ng-container *ngIf="existingContactCount > 0">
                <p>You must migrate {{existingContactsAttr.name1}} in order to remove the contact type.</p>
                <acabim-form-block
                        labelWidth="7"
                        [labelAlign]="'right'"
                        [colonize]="true">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Migrate to</acabim-form-input-label>
                        <p-dropdown [options]="migrationContactTypes" formControlName="targetContactType"></p-dropdown>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
            </ng-container>
            <ng-container *ngIf="existingContactCount > 1">
                <acabim-detail-view [meta]="existingContactsMeta" [payload]="existingContacts"></acabim-detail-view>
            </ng-container>
        </form>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onCancel()">Cancel</button>
            <button class="cas-button-action cas-button-right" [disabled]="preventMigration" (click)="step1()">{{next}}</button>
        </div>
    </ng-container>

    <ng-container *ngIf="step === 2 && migrationSuccess">
        <div class="cas-form-floating push-up-2">
            <p>{{migrationSuccessMessage | firstUp}}</p>
            <p>Now, we can safely remove the contact type.</p>
        </div>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onCancel()">Cancel</button>
            <button class="cas-button-action cas-button-right" (click)="step2()">{{next}}</button>
        </div>
    </ng-container>


    <ng-container *ngIf="step === 3 && archiveSuccess">
        <div class="cas-info">
            <h4>Done!</h4>
            <p>{{archiveSuccessMessage | firstUp}}</p>
            <button class="cas-button-action push-up-2" (click)="step3()">Close</button>
        </div>
    </ng-container>

</ng-container>

<ng-template #showLoader>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
